export default __webpack_public_path__ + "static/media/scrollcard3.d03ed25b.jpg";